import { WideErrorParam } from '../common';
import { ErrorLevel } from '../models';

export class WideError {
    level: ErrorLevel;
    message: string;
    classed: string;
    params: WideErrorParam[];

    constructor(level: ErrorLevel, message: string, params?: WideErrorParam[]) {
        this.level = level;
        this.message = message;
        this.params = params;

        switch (level) {
            case ErrorLevel.Fatal:
                this.classed = 'panel-fatal';
                break;
            case ErrorLevel.Error:
                this.classed = 'panel-error';
                break;
            case ErrorLevel.Warning:
                this.classed = 'panel-warning';
                break;
            case ErrorLevel.Info:
                this.classed = 'panel-info';
                break;
            default:
        }
    }
}